import React, { useState } from 'react';
import { connect } from 'react-redux';
import { addSeveral, addCart, showCart } from 'components/cart/actions';
import { showAvailability } from 'components/availability/actions';
import ProductEngraving from './engraving';
import DeliveryAvailability from './deliveryAvailability';
import ProductQtySelector from 'scy/QtySelector';
import ProductDiscount from './ProductDiscount';
import { fontSizeS, sansSerifLight, highlight } from 'scy/text/styles.mod.scss';
import margin from 'scy/margin.mod.scss';

function ProductAddToCart({
  product,
  address,
  selectedIngredients = [],
  addSeveral,
  addCart,
  showCart,
  showAvailability
}) {
  const [engraving, setEngraving] = useState(null);

  if (!product) return null;

  function addQtyToCart(qty) {
    let opts = {};

    if (
      engraving &&
      (engraving.line_1 || engraving.line_2 || engraving.line_3)
    ) {
      opts.engraving = {
        ...engraving,
        master_sku: product.sku_id,
        master_id: product.cart_id,
        price: product.engraving.price
      };
    }

    if (selectedIngredients.length) {
      const products = selectedIngredients
        .map(i => i.selected)
        .filter(product => !!(product && product.sku_id));
      opts.collection = product;
      addSeveral(products, qty, opts);
    } else {
      addCart(product, qty, opts);
    }

    setTimeout(showCart, 500);
  }

  const notAvailable = !!address && !product.price;
  const disabled = !address || notAvailable || product.soldout;

  return (
    <>
      {!!product.engraving && (
        <ProductEngraving setEngraving={setEngraving} product={product} />
      )}

      <DeliveryAvailability
        product={product}
        showAvailability={showAvailability}
      />

      {!!product.price && !!product.package_qty && (
        <ProductDiscount
          product={product}
          className={`${
            margin.bottom_xs
          } ${fontSizeS} ${sansSerifLight} ${highlight}`}
          iconWidth={19}
          iconHeight={19}
        />
      )}

      <ProductQtySelector
        className={`${margin.top_sm} ${margin.bottom_md}`}
        defaultQty={1}
        selectorDisabled={disabled}
        buttonDisabled={notAvailable || product.soldout}
        buttonAction={address ? addQtyToCart : showAvailability}
        buttonText={
          !address
            ? 'Check Availability'
            : product.soldout
            ? 'Sold Out'
            : notAvailable
            ? 'Currently Unavailable'
            : 'Add to Cart'
        }
      />
    </>
  );
}

const ConnectedProductAddToCart = connect(
  state => ({
    address: state.address.lat ? state.address : null,
    selectedIngredients: state.product.selectedIngredients
  }),
  {
    addSeveral,
    addCart,
    showCart,
    showAvailability
  }
)(ProductAddToCart);

export default ConnectedProductAddToCart;
